(() => {
  if (window.rpBlackFriday) return;
  const instances = new Map();
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    root.querySelector('[data-bf-motion]')?.addEventListener('click', event => {
      const paused = root.classList.toggle('bf-paused');
      event.currentTarget.setAttribute('aria-pressed', String(paused));
    }, { signal });
    let timer, toastTimer;
    const countdown = root.querySelector('[data-end-at]');
    if (countdown) {
      const end = Date.parse(countdown.dataset.endAt);
      const tick = () => {
        const left = Number.isFinite(end) ? Math.max(0, end - Date.now()) : 0;
        const values = { days: Math.floor(left / 86400000), hours: Math.floor(left / 3600000) % 24, minutes: Math.floor(left / 60000) % 60, seconds: Math.floor(left / 1000) % 60 };
        for (const [unit, value] of Object.entries(values)) {
          const element = countdown.querySelector(`[data-unit="${unit}"]`);
          if (element) element.textContent = String(value).padStart(2, '0');
        }
      };
      tick(); timer = setInterval(tick, 1000);
    }
    root.querySelectorAll('[data-code]').forEach(button => {
      button.addEventListener('click', async () => {
        const code = button.dataset.code;
        const status = root.querySelector('[data-bf-toast]');
        if (!code || !status) return;
        let copied = false;
        try { await navigator.clipboard.writeText(code); copied = true; } catch (_) {
          const field = document.createElement('textarea');
          field.value = code; field.setAttribute('aria-label', 'Discount code');
          field.style.cssText = 'position:fixed;top:0;left:-9999px';
          root.append(field); field.select();
          try { copied = document.execCommand('copy'); } catch (_) { /* Display manual copy instruction. */ }
          field.remove(); button.focus({ preventScroll: true });
        }
        status.textContent = copied ? `${code} copied` : `Please copy this code: ${code}`;
        status.classList.add('show');
        clearTimeout(toastTimer); toastTimer = setTimeout(() => status.classList.remove('show'), 4000);
      }, { signal });
    });
    root.querySelectorAll('.carousel-dots').forEach(dots => {
      const track = root.querySelector(dots.dataset.carousel);
      if (!track) return;
      const items = [...track.children];
      const buttons = [...dots.querySelectorAll('button')];
      const update = () => {
        const left = track.getBoundingClientRect().left;
        let index = 0, closest = Infinity;
        items.forEach((item, i) => {
          const distance = Math.abs(item.getBoundingClientRect().left - left);
          if (distance < closest) { closest = distance; index = i; }
        });
        buttons.forEach((button, i) => {
          button.classList.toggle('active', i === index);
          button.setAttribute('aria-pressed', String(i === index));
        });
      };
      buttons.forEach((button, i) => {
        if (!items[i]) return;
        button.addEventListener('click', () => {
          track.scrollTo({ left: track.scrollLeft + items[i].getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: reduced() ? 'instant' : 'smooth' });
        }, { signal });
      });
      track.addEventListener('scroll', update, { passive: true, signal });
      update();
    });
    instances.set(root, () => { controller.abort(); clearInterval(timer); clearTimeout(toastTimer); });
  }
  const scan = context => {
    if (context.matches?.('[data-bf-root]')) init(context);
    context.querySelectorAll('[data-bf-root]').forEach(init);
  };
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of instances) if (event.target.contains(root)) { cleanup(); instances.delete(root); }
  });
  window.rpBlackFriday = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
})();
